import React, { FC } from 'react';
import Typography from './Typography';

type Props = {
  darkMode?: boolean;
}

const Label: FC<Props> = ({ children, darkMode = false }) => {
  if (!children) {
    return null;
  }
  return (
    <Typography tag="small" className="mb-1" color={darkMode ? 'white' : undefined} bold ellipsis>
      {children}
    </Typography>
  );
};

export default Label;
